import { useSiteLabellingState } from "./_store"
import { ToggleNotesHeaderCell } from "../../../../../../../components/table";

const DLMLabellingNotesHeaderCell = () => {    

  const { hasNotes, toggleAllNotes, showAllNotes } = useSiteLabellingState(state => state);      

  return (    
    <ToggleNotesHeaderCell hasNotes={hasNotes} show={showAllNotes} toggleNotes={toggleAllNotes} />
  )
}

export {DLMLabellingNotesHeaderCell}
